<template>
  <div class="page-container">
    <div class="page-content">
      <!-- Page Header -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3">
          <h1 class="text-white">
            <i class="mdi mdi-account-group"></i> Usuários
          </h1>
          <div class="d-flex gap-2 ml-auto align-items-center">
            <button
              v-if="$can('user-store')"
              @click="redirect('create-edit-user')"
              class="btn btn-outline-white"
            >
              <i class="fa fa-plus-circle"></i>
              <span class="d-none d-md-inline-block ml-2">Criar Usuário</span>
            </button>
            <button
              v-if="$can('user-store')"
              @click="showModalInvite()"
              class="btn btn-outline-white"
            >
              <i class="fas fa-reply"></i>
              <span class="d-none d-md-inline-block ml-2">Convidar</span>
            </button>
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-outline-white"
                v-b-toggle.collapse-2
              >
                <i class="fa fa-filter"></i>
                <span class="d-none d-md-inline-block ml-2">Filtros</span>
              </button>
            </div>
          </div>
        </div>
      </div>

     <div class="row justify-content-end mb-3">
        <div class="col-12 col-lg-5">
          <b-collapse id="collapse-2" class="w-100">
            <b-input-group>
              <!-- Campo de Filtro -->
              <b-form-input
                v-model="filter"
                @keyup.enter="applyFilter"
                placeholder="Digite o que deseja buscar"
              ></b-form-input>

              <!-- Botão de Buscar -->
              <b-input-group-prepend>
                <span
                  class="input-group-text cursor-pointer"
                  @click="applyFilter"
                  v-b-tooltip.hover
                  title="Buscar"
                >
                  <i class="fa fa-search"></i>
                </span>
              </b-input-group-prepend>

              <!-- Botão de Limpar -->
              <b-input-group-append>
                <span
                  class="input-group-text cursor-pointer"
                  @click="clearFilter"
                  v-b-tooltip.hover
                  title="Limpar"
                >
                  <i class="fa fa-times"></i>
                </span>
              </b-input-group-append>
            </b-input-group>
          </b-collapse>
        </div>
      </div>

      <!-- Alertas -->
      <div v-if="alertMessage" class="col-md-13 mb-2">
        <b-alert show variant="danger">{{ alertMessage }}</b-alert>
      </div>
      <div v-if="inviteMessage" class="col-md-13 mb-2">
        <b-alert show variant="success">{{ inviteMessage }}</b-alert>
      </div>

      <!-- Loading -->
      <div
        v-if="loading"
        class="overlay-modal d-flex align-items-center justify-content-center mb-3"
      >
        <b-spinner label="Carregando..."></b-spinner>
      </div>

      <!-- Tabela dentro de Card -->
      <div class="card bg-light-gray">
        <div class="card-body pt-1">
          <div class="table-responsive">
            <table class="table-v3 w-100" role="table" aria-busy="false">
              <thead role="rowgroup">
                <tr role="row">
                  <th class="nowrap">Nome</th>
                  <th class="nowrap">Documento</th>
                  <th class="nowrap">Telefone</th>
                  <th class="nowrap">Email</th>
                  <th class="nowrap">Data de Criação</th>
                  <th class="nowrap">Cargo</th>
                  <th class="nowrap text-center">Acesso Painel</th>
                  <th class="nowrap text-center">Acesso Email</th>
                  <th class="nowrap text-center">Ações</th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr v-for="(item, idx) in items" :key="idx" role="row">
                  <td role="cell" class="font-12">{{ truncateText(item.name) }}</td>
                  <td role="cell" class="font-12">{{ item.document | formatDocument }}</td>
                  <td role="cell" class="font-12">{{ item.phone }}</td>
                  <td role="cell" class="font-12">{{ item.email }}</td>
                  <td role="cell" class="font-12">
                    {{ item.created_at ? formatDateTimeLocal(item.created_at) : '---' }}
                  </td>
                  <td role="cell" class="font-12">{{ item.role_name }}</td>
                  <td role="cell" class="font-12 text-center">
                    <i class="fas fa-check-circle text-success" v-if="item.has_access_panel"></i>
                    <i class="fas fa-ban text-danger" v-else></i>
                  </td>
                  <td role="cell" class="font-12 text-center">
                    <i class="fas fa-check-circle text-success" v-if="item.has_access_policy_mail"></i>
                    <i class="fas fa-ban text-danger" v-else></i>
                  </td>
                  <td role="cell" class="font-12 text-center">
                    <div class="btn-group">
                      <button
                        class="btn btn-action"
                        v-if="$can.any(['user-edit','user-update'])"
                        @click="redirect('create-edit-user', null, { clone: item.id })"
                        title="Clonar Usuário"
                      ><i class="far fa-copy"></i></button>
                      <button
                        class="btn btn-action"
                        v-if="$can.any(['user-edit','user-update'])"
                        @click="redirect('create-edit-user',{ userId: item.id })"
                        title="Editar"
                      ><i class="fas fa-pen"></i></button>
                      <button
                        class="btn btn-action"
                        v-if="$can.any(['user-edit','user-update']) && isMaster()"
                        @click="showModalDelete(item)"
                        title="Excluir"
                      ><i class="fas fa-trash"></i></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginação 3 números -->
            <nav aria-label="Paginação" >
              <b-pagination
                @page-click="pageChanged"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
          </nav>  
        </div>
      </div>
    </div>

    <!-- Delete Modal -->
    <b-modal
      id="show-modal-delete"
      ref="showModalDelete"
      size="md"
      centered
      hide-footer
      class="mt-4"
    >
      <template #modal-title>Excluir Usuário?</template>
      <p class="px-3">
        Deseja excluir o usuário "<strong>{{ data.name }}</strong>" ({{ data.document | formatDocument }})?
      </p>
      <div class="d-flex justify-content-end px-3 pb-3">
        <b-button variant="outline-secondary" @click="$bvModal.hide('show-modal-delete')">
          <i class="fa fa-angle-left mr-1"></i>Voltar
        </b-button>
        <b-button variant="danger" class="ml-2" @click="deleteUser(data.id)">
          <i class="fas fa-times mr-1"></i>Confirmar
        </b-button>
      </div>
    </b-modal>

    <div class="modal">
      <b-modal
        id="show-modal-invite"
        ref="showModalInvite"
        class="mt-4"
        size="md"
        centered
        hide-footer
      >
        <template #modal-title> Convidar usuário </template>

        <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
          <b-form
            @submit.stop.prevent="handleSubmit(inviteUser)"
            class="form"
            autocomplete="off"
          >
            <div class="row">
              <div v-if="alertMessage" class="col-12">
                <b-alert show :variant="alertVariant">{{
                  alertMessage
                }}</b-alert>
              </div>

              <div class="col-12">
                <label class="dbo-ui"
                  >Informe o e-mail que você deseja convidar:</label
                >
              </div>

              <div
                class="col-12"
                v-for="(email, idx) in emailInvite"
                v-bind:key="idx"
              >
                <div class="pb-2">
                  <validation-provider
                    name="Email"
                    rules="required|email"
                    v-slot="validationContext"
                    vid="email"
                  >
                    <div class="d-flex justify-content-center group-button">
                      <b-form-input
                        type="email"
                        v-model="emailInvite[idx]"
                        :name="`emailInvite[${idx}].email`"
                        :state="getValidationState(validationContext)"
                        placeholder="Preencha o e-mail"
                      ></b-form-input>

                      <button
                        class="btn btn-outline-primary"
                        @click="removeEmailInvite(idx)"
                        style="border-radius: 0px 20px 20px 0px;"
                      >
                        <i class="fa fa-close"></i>
                      </button>
                    </div>
                    <div class="error">
                      <b-form-invalid-feedback>{{
                        validationContext.errors[0]
                      }}</b-form-invalid-feedback>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-end mb-3">
                <a class="btn btn-outline-primary btn-sm" @click="addEmailInput"
                  >Adicionar e-mail <i class="fa fa-plus ml-2"></i
                ></a>
              </div>
            </div>

            <div class="d-flex justify-content-between">
              <a
                @click="$bvModal.hide('show-modal-invite')"
                class="btn btn-outline-secondary"
                ><i class="fa fa-angle-left"></i> Voltar</a
              >

              <button class="btn btn-md btn-primary" :disabled="invalid">
                <i class="fas fa-reply"></i> Convidar
              </button>
            </div>
          </b-form>
        </validation-observer>
      </b-modal>
    </div>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import userService from "@/services/user";
import authenticationService from "@/services/authentication";
import dateFormatter from "@/mixins/dateFormatter";

export default {
  name: "list-users",
  mixins: [dateFormatter],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    perPage: 10,
    currentPage: 1,
    items: [],
    filter: null,
    data: [],
    loading: false,
    emailInvite: [],
    inviteMessage: "",
    totalRows: 0,
  }),
  created() {
    this.getUsers();
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRows / this.perPage));
    },
    pages() {
      const total = this.totalPages;
      if (total <= 3) return Array.from({ length: total }, (_, i) => i + 1);
      if (this.currentPage === 1) return [1, 2, 3];
      if (this.currentPage === total) return [total - 2, total - 1, total];
      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    },
    fields() {
      var columns = [
        {
          key: "name",
          label: "Nome",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui rounded-top",
        },
        {
          key: "document",
          label: "Documento",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui",
        },
        {
          key: "phone",
          label: "Telefone",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui",
        },
        {
          key: "email",
          label: "Email",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui",
        },
        {
          key: "created_at",
          label: "Data de criação",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui",
        },
        {
          key: "role_name",
          label: "Cargo",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui",
        },
        {
          key: "has_access_panel",
          label: "Acesso ao Painel",
          tdClass: "font-14 justify-content-center",
          thClass: "table-pretty dbo-ui",
        },
        {
          key: "has_access_policy_mail",
          label: "Acesso ao Email de Apólice",
          tdClass: "font-14 justify-content-center",
          thClass: "table-pretty dbo-ui",
        },
      ];

      if (this.isMaster()) {
        columns.push({
          key: "utm",
          label: "UTM",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui",
        });
      }

      columns.push({
        key: "id",
        label: "Ação",
        tdClass: "column-size-share font-12",
        thClass: "table-pretty dbo-ui rounded-top ",
      });
      return columns;
    },
  },
  methods: {
    pageChanged(bvEvent, pageNumber) {
      this.currentPage = pageNumber;
      this.getUsers();
    },
    getUsers() {
      this.resetAlert();
      this.loading = true;
      userService
        .users({
          page: this.currentPage,
          per_page: this.perPage,
          filter: this.filter,
        })
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.items = response.data.data;
          this.totalRows = response.data.total;
        })
        .catch(() => {
          this.showError("Não foi possível recuperar os usuários.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redirect(routeName, params = null, query = null) {
      this.$router.push({ name: routeName, params: params, query: query });
    },
    isMaster() {
      return authenticationService.isMaster();
    },
    showModalDelete(data) {
      this.data = data;
      this.$refs.showModalDelete.show();
    },
    deleteUser(user_id) {
      this.loading = true;
      userService
        .destroy(user_id)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.$refs.showModalDelete.hide();
          this.getUsers();
        })
        .catch(() => {
          this.showError("Não foi possível deletar o usuário.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    showModalInvite() {
      this.emailInvite = [""];
      this.$refs.showModalInvite.show();
    },
    inviteUser() {
      this.resetAlert();
      userService
        .invite(this.emailInvite)
        .then((response) => {
          var data = response.data.data;
          console.log(response);

          var msg = "";
          if (data.existings.length) {
            msg += "- Usuários existentes:\n";
            msg += data.existings.map((obj) => obj.email).join(", ") + "\n";
          }

          if (data.inviteds.length) {
            msg += "- Convites enviados:\n";
            msg += data.inviteds.map((obj) => obj.email).join(", ") + "\n";
          }

          this.inviteMessage = msg;
          this.$refs.showModalInvite.hide();
          return;
        })
        .catch(() => {
          this.showError("Não foi possível enviar os convites.");
        });
    },
    addEmailInput() {
      this.emailInvite.push("");
    },
    removeEmailInvite(idx) {
      this.emailInvite.splice(idx, 1);
      this.$refs.observer.validate();
    },
    clearFilter() {
      this.currentPage = 1;
      this.filter = "";
      this.getUsers();
    },
    applyFilter() {
      this.currentPage = 1;
      this.getUsers();
    },
    truncateText(text, maxChar = 15) {
      return text.length > maxChar ? `${text.substring(0, maxChar)}...` : text;
    },
  },
};
</script>

<style>
</style>
